import { put, call } from 'redux-saga/effects';
import { rolesList, rolesAdd, rolesEdit, rolesUpdate, rolesDelete, rolesPermissionUpdate } from '../services/rolesPermissionsService'; 

import * as types from '../actions';

export function* rolesListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(rolesList, payload);
      yield put({ type: types.ROLES_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.ROLES_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* rolesAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(rolesAdd, payload);
    yield put({ type: types.ROLES_ADD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ROLES_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* rolesEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(rolesEdit, payload);
    yield put({ type: types.ROLES_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ROLES_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* rolesUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(rolesUpdate, payload);
    yield put({ type: types.ROLES_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ROLES_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* rolesDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(rolesDelete, payload);
    yield put({ type: types.ROLES_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ROLES_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* rolesPermissionUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(rolesPermissionUpdate, payload);
    yield put({ type: types.ROLES_PERMISSION_UPDATE_SUCCESS , response })
          
  } catch(error) {
    yield put({ type: types.ROLES_PERMISSION_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

